import { useState } from 'react';

export const useMobileWorkspace = () => {
  const [mobileView, setMobileView] = useState<'files' | 'content'>('files');

  return {
    mobileView,
    setMobileView,
  };
};